// Polyfills must load first
import './utils/async-hooks-polyfill.js';
import './utils/global-polyfills.js';
import './utils/langchain-patch.js';
import './utils/apiClient.js'; // Override fetch globally — all API calls encrypted

// Bundle inherited utility and icon styles locally for reliable startup.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Theme — CSS custom properties on :root, must load before any component
import './components/agentHub/css/theme.css';
// Global app styles + Bootstrap overrides
import './css/app.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App.jsx';
import './styles/design-system.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
